import React from "react";
import t, {changeLanguage} from "../../components/I18N/TranslateHelpers";
import {GetCurrentLocale, isResponsive, isSmartphone} from "../../components/Utils";

const SearchProductCTA = () => {
  const locale = GetCurrentLocale();
  changeLanguage(locale)

  return (
    <section className="cta bg-primary bg-cta-search-mat">
      <div className="container p-5">
        <div className="row align-items-center mb-0">
          <header className="section-heading col-lg-6 col-md-12 text-center mb-0">
            <h3 className="section-title h1 text-white mb-2">{t('looking_for_product')}</h3>
            <p className="lead pt-3 mb-0 text-white">{t('looking_for_text')}</p>
          </header>
          <form className="mx-auto mb-0 col-lg-5 col-md-8 col-sm-12">
            <div className="row g-2 w-100">
              <div className="col flex-grow bg-white py-2 px-2 borderradius30">
                <div className="input-group space-between">
                  <div className="select-wrapper col">
                    <select className="form-select">
                      <option>Industrie</option>
                      <option>Électrique</option>
                      <option>Construction</option>
                      <option>Alimentaire</option>
                      <option>Sur la route</option>
                      <option>Service de secours</option>
                      <option>Administratif</option>
                      <option>Seveso</option>
                      <option>ATEX</option>
                      <option>Décontamination</option>
                    </select>
                  </div>
                  <button className="btn btn-primary btn-lg btn-rounded btn-padding">
                    {
                      isResponsive || isSmartphone ? <i className="fa fa-search"/> : t('search')
                    }
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </section>
  )
}
export default SearchProductCTA;
